import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuBtn, ReponseMenu, StyledWorkflowCard, StyleItem } from './WorkflowCard.style';
import { PiDotsThreeOutlineVertical } from 'react-icons/pi';
import folderIcon from '../../../assets/icon-folder-files.svg';
import CreateWorkflowModal from '../CreateWorkflowModal';
import ModalContainer from '../../ModalContainer';
import DeleteWorkflowModal from '../DeleteWorkflowModal';

const WorkflowCard = ({ workflowCardsData }) => {
  const navigate = useNavigate();

  return (
    <>
      {workflowCardsData?.map((card, index) => (
        <StyledWorkflowCard key={index}>
          <div className="card-header">
            <div className="img-box">
              <img src={folderIcon} alt="img" />
            </div>
            <ReponseMenu
              menuButton={
                <MenuBtn>
                  <PiDotsThreeOutlineVertical />
                </MenuBtn>
              }>
              <StyleItem onClick={() => navigate(`/workflows/${card.workflow_id}`)}>
                <div className="text">View Workflow</div>
              </StyleItem>
              <ModalContainer
                width="750"
                title="Edit Workflow"
                content={({ onClose }) => <CreateWorkflowModal onClose={onClose} isEdit={card} />}
                btnComponent={({ onClick }) => (
                  <StyleItem onClick={onClick}>
                    <div className="text">Edit Details</div>
                  </StyleItem>
                )}
              />
              <ModalContainer
                width="750"
                title="Confirm Workflow Deletion"
                content={({ onClose }) => <DeleteWorkflowModal onClose={onClose} isEdit={card} />}
                btnComponent={({ onClick }) => (
                  <StyleItem onClick={onClick}>
                    <div className="text" style={{ color: 'rgba(215, 65, 32, 1)' }}>
                      Delete Workflow
                    </div>
                  </StyleItem>
                )}
              />
            </ReponseMenu>
          </div>
          <div className="text-box">
            <strong className="title">{card?.name}</strong>
            <p>{card?.description}</p>
          </div>
        </StyledWorkflowCard>
      ))}
    </>
  );
};

export default WorkflowCard;
